import {
  getSuggestedActionGroups,
  getSuggestedActionGroupsList,
  getSuggestedActionUsersList,
  getSuggestedActionsStatus,
} from '@ms/yammer-data/dist/domains/suggestedActions/selectors';
import type { SuggestedActionSurface } from '@ms/yammer-graphql/dist/types';

import { useSelector } from '../useSelector';

type UseStatus = (surface: SuggestedActionSurface) => ReturnType<typeof getSuggestedActionsStatus>;
export const useStatus: UseStatus = (surface) => useSelector((state) => getSuggestedActionsStatus(state, surface));

type UseSuggestedActionGroupsForLightbox = () => ReturnType<typeof getSuggestedActionGroups>;
/**
 * @deprecated PERFORMANCE This will return a new array instance of constructed objects whenever the suggested action groups
 * list or ANY group, cover image or group member count changes across the entire store. This should be replaced by a
 * `useSuggestedActionGroupIdsForLightbox` selector, all other fields should be selected by individual (child) components as needed.
 */
export const useSuggestedActionGroupsForLightbox: UseSuggestedActionGroupsForLightbox = () =>
  useSelector((state) => getSuggestedActionGroups(state, 'WEB_LIGHTBOX'));

type UseSuggestedActionGroupsListForLightbox = () => ReturnType<typeof getSuggestedActionGroupsList>;
export const useSuggestedActionGroupsListForLightbox: UseSuggestedActionGroupsListForLightbox = () =>
  useSelector((state) => getSuggestedActionGroupsList(state, 'WEB_LIGHTBOX'));

type UseSuggestedActionUsersListForLightbox = () => ReturnType<typeof getSuggestedActionUsersList>;
export const useSuggestedActionUsersListForLightbox: UseSuggestedActionUsersListForLightbox = () =>
  useSelector((state) => getSuggestedActionUsersList(state, 'WEB_LIGHTBOX'));
